import { FC } from "react";

import Colors from "@constants/Colors";
import { ReactComponent as ChipCloseIcon } from "@icons/ChipCloseIcon.svg";
import { Chip } from "@mui/material";
import { TypographyH5 } from "@shared-ui-components/CustomTypography";

import { CustomFilterStyle } from "../../helper";
import { FilterTitleWrapper, FilterWrapper, MainFilterWrapper } from "./style";

interface FilterType {
  filterType: NotificationFitlerType[];
  handleDelete: (e: string) => void;
  handleClick: (e: string) => void;
}

const Filter: FC<FilterType> = ({ filterType, handleDelete, handleClick }) => {
  return (
    <MainFilterWrapper>
      <FilterTitleWrapper>
        <TypographyH5 className="customTitle">Filter By</TypographyH5>
      </FilterTitleWrapper>
      <FilterWrapper>
        {filterType?.map((event) => {
          return (
            event.isSelected && (
              <Chip
                key={event.value}
                label={event.value}
                variant="outlined"
                onDelete={() => handleDelete(event.value)}
                deleteIcon={<ChipCloseIcon />}
                sx={{
                  ...CustomFilterStyle,
                  backgroundColor: Colors.neutral_gray_200,
                  border: `1px solid ${Colors.primary_900}`,
                }}
              />
            )
          );
        })}
        {filterType?.map(
          (event) =>
            !event.isSelected && (
              <Chip
                key={event.value}
                label={event?.value}
                variant="outlined"
                onClick={() => handleClick(event?.value)}
                sx={{
                  ...CustomFilterStyle,
                  backgroundColor: "transparent",
                  border: `1px solid ${Colors.neutral_gray_300}`,
                }}
              />
            )
        )}
      </FilterWrapper>
    </MainFilterWrapper>
  );
};

export default Filter;
